import { useEffect, useState } from 'react';
import CreatableSelect from 'react-select/creatable';
import ExpensesService from '@/services/ExpensesService';

function ExpenseTags({ selectedTags, onTagsChange, placeholder = 'Select or create tags...' }) {
  const [availableTags, setAvailableTags] = useState([]);

  useEffect(() => {
    async function fetchTags() {
      const { data, error } = await ExpensesService.getTags();
      if (!error) {
        setAvailableTags(data.map(tag => ({ value: tag, label: tag })));
      } else {
        console.error('Failed to fetch tags:', error);
      }
    }

    fetchTags();
  }, []);

  return (
    <CreatableSelect
      isMulti
      name="tags"
      options={availableTags}
      value={selectedTags}
      onChange={onTagsChange}
      placeholder={placeholder}
      className="react-select"
      classNamePrefix="react-select"
    />
  );
}

export default ExpenseTags;
